import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const selectFlowEditorTabsState = (state: RootState) => state.flowEditorTabs;

export const selectTabs = createSelector(
  [selectFlowEditorTabsState],
  (tabsState) => tabsState.tabs,
);

export const selectActiveTabId = createSelector(
  [selectFlowEditorTabsState],
  (tabsState) => tabsState.activeTabId,
);

export const selectActiveTab = createSelector([selectTabs, selectActiveTabId], (tabs, activeId) => {
  if (!activeId) return null;
  return tabs.find((tab) => tab.flowId === activeId) ?? null;
});

export const selectTabByFlowId = (flowId: string) =>
  createSelector([selectTabs], (tabs) => tabs.find((tab) => tab.flowId === flowId) ?? null);

export const selectIsTabDirty = (flowId: string) =>
  createSelector([selectTabs], (tabs) => tabs.find((t) => t.flowId === flowId)?.isDirty ?? false);

/** Alguma aba de fluxo do agente com alteração não salva — o FlowBuilder trabalha sobre o rascunho salvo. */
export const selectHasDirtyTabForAgent = (agentId: string) => (state: RootState) =>
  state.flowEditorTabs.tabs.some((tab) => tab.negotiationAgentId === agentId && tab.isDirty);
